export { default } from './SkillXPEvolutionSkeleton';
